import { createAsyncThunk } from '@reduxjs/toolkit'
import MetricConfiguration from './metric-configuration-model'
import {
  delete_metricConfiguration,
  load_metricConfigurations,
  store_metricConfiguration,
} from './metricConfiguration-service'

export const LoadMetricConfigurationsAsync = createAsyncThunk<any, any>(
  'composer/load/metricConfiguration',
  async (params: { uid: string }) => {
    return await load_metricConfigurations(params)
  },
)

export const CreateMetricConfigurationAsync = createAsyncThunk<any, any>(
  'composer/create/metricConfiguration',
  async (params: MetricConfiguration) => {
    return await store_metricConfiguration(params)
  },
)

export const DeleteMetricConfigurationAsync = createAsyncThunk<any, any>(
  'composer/delete/metricConfiguration',
  async (params) => {
    return await delete_metricConfiguration(params)
  },
)
